import api from './api';

const API_BASE = '/tasks/api/time-entries';

const timesheetService = {
  // Get all time entries with optional filters
  getTimeEntries: (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const url = params ? `${API_BASE}/?${params}` : `${API_BASE}/`;
    return api.get(url);
  },

  // Get a single time entry by ID
  getTimeEntry: (id) => {
    return api.get(`${API_BASE}/${id}/`);
  },

  // Create a manual time entry
  createTimeEntry: (data) => {
    return api.post(`${API_BASE}/`, data);
  },

  // Update a time entry
  updateTimeEntry: (id, data) => {
    return api.put(`${API_BASE}/${id}/`, data);
  },

  // Delete a time entry
  deleteTimeEntry: (id) => {
    return api.delete(`${API_BASE}/${id}/`);
  },

  // Start timer for a task
  startTimer: (taskId) => {
    return api.post(`${API_BASE}/start_timer/`, { task_id: taskId });
  },

  // Stop current timer
  stopTimer: (workNote = '') => {
    return api.post(`${API_BASE}/stop_timer/`, { work_note: workNote });
  },

  // Get active timer
  getActiveTimer: () => {
    return api.get(`${API_BASE}/active_timer/`);
  },

  // Switch to a different task (stop current, start new)
  switchTask: (newTaskId, workNote = '') => {
    return api.post(`${API_BASE}/switch_task/`, {
      new_task_id: newTaskId,
      work_note: workNote,
    });
  },
};

export default timesheetService;
